import React from 'react'
import {
    Button,
} from 'antd'

export default function (
    {
        exists,
        action,

        canSave,
        onSave,
    }
)
{
    return (
        <Button 
            type="primary" 
            onClick={onSave}
            loading={action === 'saving'}
            disabled={(!!action && action !== 'saving') || !canSave}
        >
            {action === 'saving' && `กำลัง`}
            {!!exists ? `บันทึก` : `สร้าง`}
        </Button>
    )
}